export const GET_MENUS = 'GET_MENUS';
export const GET_MENU = 'GET_MENU';
export const CHANGE_FILTER = 'CHANGE_FILTER';
export const SEARCH_BY_LETTER = 'SEARCH_BY_LETTER';
export const LOADING = 'LOADING';
